import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'riskOverviewMap',
  pure: true
})
export class RiskOverviewMapPipe implements PipeTransform {
  statusMap = {
    F: 'Failure',
    H: 'High',
    M: 'Medium',
    L: 'Low'
  };

  constructor() {}

  transform(type: string): string {
    return this.statusMap[type] || type;
  }
}
